export default {
    header: 'NVR Punch Log',
    searchText: 'Search by Name / Employee ID',
    search: 'Search',
    type: 'Type',
    employeeId: 'Employee ID',
    name: 'Name',
    imageSearch: 'Employee Image Search',
    date: 'Date',
    time: 'Time',
    image: 'Image',
    location: 'Location',
    temperature: 'Temp',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    somethingWrong: 'Something went wrong'
}
